const inlineBlockStyle = {
  display: 'inline-block' as any
}

export { inlineBlockStyle }
